<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Call Logs</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content class="mat-typography" fxFlex>
    <app-call-logs-v2-grid #callLogsGrid [staticFilter]="data.filter"></app-call-logs-v2-grid>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onProcessConfirm()" [promiseBtn]="onConfirm">Export</button>
  </mat-dialog-actions>
</div>




